<script>/**
 * @overview 主页面 - 菜单
 */

import baseUrl from '../../utils/api';

export default {
  name: 'MainMenu',
  inject: ['reload'],
  data: () => ({
    menus: [],
    show: true,
  }),
  computed: {
    children() {
      return this.menus.flatMap(item => item.children);
    },
    defaultActive() {
      const { path } = this.$route;
      const pattern = /(\/\w+)/;

      const match = (pattern.exec(path) || [])[0];
      const target = this.children.find(({ index }) => index.startsWith(match));

      return target ? target.index : match;
    },
    school() {
      return this.$store.state.choicesSchool;
    },
    user() {
      return this.$store.state.mainUser;
    },
  },
  watch: {
    user(val) {
      this.show = false;
      this.$nextTick(() => {
        this.setMenus();
        this.show = true;
      });
    },
  },
  created() {
    this.setMenus();
  },
  methods: {
    setMenus() {
      this.menus = [
        // {
        //   name: '课程商品',
        //   icon: 'el-icon-s-goods',
        //   children: [
        //     {
        //       name: '商品列表',
        //       index: '/goods',
        //     },
        //   ],
        // },
        {
          name: '课程商品',
          icon: 'el-icon-s-goods',
          children: [
            {
              name: '课程汇总',
              index: '/courseGoods',
            },
            {
              name: '授权统计',
              index: '/authority',
            },
            {
              name: '耗课统计',
              index: '/consumption',
            },
            {
              name: '上课统计',
              index: '/class',
            },
          ],
        },
        {
          name: '校区管理',
          icon: 'el-icon-s-operation',
          children: [
            {
              name: '校区列表',
              index: '/campus',
            },
            {
              name: '授权统计',
              index: '/school/authorize',
            }
          ],
        },
        {
          name: '课件管理',
          icon: 'el-icon-s-ticket',
          children: [
            {
              name: '擎想系统课件管理',
              index: '/manageYun',
            },
          ],
        }
      ];
    },
    /**
     * @param {String} index 菜单项的唯一标识，同时也是点击该菜单项所进入的页面路由
     */
    onSelectMenu(index) {
      switch (index) {
        case 'school_system': // 校区后台
          window.open(`${baseUrl}/oauth/authorize?
                          client_id=4&
                          redirect_uri=${this.$domain.schoolManagement}&
                          response_type=token&
                          scope=&state=auto`);
          break;
        case 'admin_system': // 超管后台
          window.open(`${baseUrl}/management/auth/login`);
          break;
        case 'course_system': // 课件后台
          window.open(`${baseUrl}/oauth/authorize?
                          client_id=5&
                          redirect_uri=${this.$domain.courseware}&
                          response_type=token&
                          scope=&state=auto`);
          break;
        case 'schoolcenter_system': // 教育平台
          window.open(`https://management.schoolcenter.yunkedun${/test/.test(baseUrl) ? 'test' : ''}.com`);
          break;
        default:
          this.$router.push(`${index}?page=1&per_page=10&order[id]=desc`);
      }
    },
    goIndex() {
      // this.$router.push('/');
    },
  },
};
</script>

<template>
  <div
    v-if="show"
    class="main-menu">
    <h1
      class="main-menu__title"
      @click="goIndex">擎想系统运营管理系统</h1>
    <el-menu
      :default-active="defaultActive"
      unique-opened
      @select="onSelectMenu"
    >
      <template v-for="(menu, index) in menus">
        <el-submenu
          v-if="!menu.noChildren"
          :index="`${index}`">
          <template slot="title">
            <i :class="menu.icon"/>
            <span>{{ menu.name }}</span>
          </template>
          <el-menu-item
            v-for="submenu in menu.children"
            :key="submenu.index"
            :index="submenu.index"
            style="padding-left:55px;"
          >
            <span slot="title">{{ submenu.name }}</span>
          </el-menu-item>
        </el-submenu>
        <el-menu-item
          v-else
          :index="menu.index"
          class="no_children">
          <i :class="menu.icon"/>
          <span slot="title">{{ menu.name }}</span>
        </el-menu-item>
      </template>
    </el-menu>
  </div>
</template>

<style lang="scss">
.main-menu {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 200px;
  text-align: center;
  .main-menu__title {
    padding: 1.2em 0;
    font-size: 16px;
    background: #002140;
    margin: 0;
    color: #fff;
    cursor: pointer;
  }
  .el-menu {
    flex: auto;
    background: #001529;
    border: none;
    text-align: left;
  }
  .el-submenu__title {
    font-size: 14px;
    letter-spacing: 1px;
    color: rgba(255, 255, 255, 0.65);
    i {
      color: rgba(255, 255, 255, 0.65);
    }
    &:hover, &:hover i{
      background: none;
      color: #fff;
    }
  }
  .el-submenu {
    .el-menu-item {
      background: #000c17;
      color: rgba(255, 255, 255, 0.65);
      padding: 0;
      &:focus, &:hover {
        background: #000c17;
        color: #fff;
      }
    }
  }
  .el-menu-item {
    &.is-active {
      color: #fff !important;
      background: var(--color-primary) !important;
    }
    &.no_children {
      color: rgba(255,255,255,0.65);
      &:hover {
        color: rgba(255,255,255, 1);
        background: none;
        i {
          color: #fff;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Main/Menu.vue